import React from "react";
import { GridColumns, DataGrid } from "@mui/x-data-grid";
import { IResourceComponentsProps, usePermissions } from "@refinedev/core";
import { useDataGrid, DateField, EditButton, List } from "@refinedev/mui";
import { UserEntityRoleEnum } from "generated";

export const UserList: React.FC<IResourceComponentsProps> = () => {
  const { dataGridProps } = useDataGrid();

  const data = usePermissions();
  const isAdmin = data?.data === UserEntityRoleEnum.Admin;

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "createdAt",
        flex: 1,
        headerName: "Date",
        minWidth: 250,
        renderCell: function render({ value }) {
          return <DateField value={value} />;
        },
      },
      {
        field: "name",
        flex: 1,
        headerName: "Name",
        minWidth: 200,
      },
      {
        field: "email",
        flex: 1,
        headerName: "Email",
        minWidth: 200,
      },
      {
        field: "phoneNumber",
        flex: 1,
        headerName: "Phone Number",
        minWidth: 200,
      },
      {
        field: "role",
        flex: 1,
        headerName: "Role",
        minWidth: 200,
      },
      {
        field: "actions",
        headerName: "Actions",
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              {isAdmin ? <EditButton hideText recordItemId={row.id} /> : null}
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
      },
    ],
    [isAdmin]
  );

  return (
    <List canCreate={isAdmin}>
      <DataGrid {...dataGridProps} columns={columns} autoHeight />
    </List>
  );
};
